import {ServiceUnavailableError} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

interface GlobalErrorFallbackProps {
  resetErrorBoundary: () => void
}

export const GlobalErrorFallback = ({resetErrorBoundary}: GlobalErrorFallbackProps) => {
  const {t} = useTranslation()

  return (
    <div className="bg-page_background w-full">
      <ServiceUnavailableError
        title={t('suite.globalErrorFallback.title')}
        description={t('suite.globalErrorFallback.description')}
        refreshText={t('suite.globalErrorFallback.refreshPage')}
        onRefresh={() => {
          resetErrorBoundary()
          window.location.reload()
        }}
        data-cy="global_error_fallback"
      />
    </div>
  )
}
